<template>
	<div class="home-footer">
		<div class="footer-cont">
			<ul class="relevant">
				<li>中国办事处信息</li>
				<li><i class="Icon1"></i>北京市海淀区学院南路12号-北京师范大学京师科技大厦A座13层</li>
				<li><i class="Icon2"></i>13699291394</li>
				<li><i class="Icon3"></i>contact.china@brest-bs.com</li>
				<li><i class="Icon4"></i>www.brest-bs.com.cn</li>
			</ul>
		</div>
		<div style="clear: both;"></div>
		<div class="friend">
			<ul class="friend-item">
				<p class="c1">常用链接</p>
				<li>
					<a href="https://www.wdecloud.com/" target="_blank">伟东云教育集团</a>
				</li>
				<li>
					<a href="http://jsj.moe.gov.cn/" target="_blank">教育部涉外监管网</a>
				</li>
        <li>
					<a href="http://www.yzvet.com/" target="_blank">国际硕博</a>
				</li>
				<!--<li><a href="http://wps.hainayx.com/index?channelCode=1-weixin-211">招生报名</a></li>
    	 	<li><router-link to="/studentSearch">入学查询</router-link></li>
    	 	<li><router-link to="/NewsList">BBS新闻</router-link></li>-->
			</ul>
		</div>
		<div class="copyright">
			<div class="copyright-text">
				<p>Copyright © 1962 - 2025 BREST BUSINESS SCHOOL
					<a href="https://brest-bs.com/" target="_blank">布雷斯特高等商学院</a>
				</p>
				<p><a href="http://beian.miit.gov.cn/" target="_blank">版权所有蜀ICP备18014873号</a>
				<span style="margin-left: 5px;">成都伟东海纳易学教育科技有限公司</span></p>

			</div>
		</div>
	</div>
</template>
<script>
	export default {
		name: "HomeFooter",
		data() {
			return {};
		}
	};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
	.home-footer {
		width: 100%;
		height: 650px;
		background: url(../assets/images/footer.png) no-repeat;
		background-size: 100% 600px;
		position: relative;
	}

	.footer-cont {
		width: 100%;
		padding-top: 53px;
	}

	.relevant {
		width: 85%;
		margin: 0 auto;
	}

	.relevant li {
		font-size: 26px;
		color: #fff;
		line-height: 44px;
	}

	.Icon1:before {
		content: "";
		background: url(../assets/images/address.png) no-repeat;
		background-size: 16px 22px;
		display: inline-block;
		width: 16px;
		height: 22px;
		vertical-align: middle;
		margin-right: 13px;
	}

	.Icon2:before {
		content: "";
		background: url(../assets/images/dianhua.png) no-repeat;
		background-size: 19px 19px;
		display: inline-block;
		width: 19px;
		height: 19px;
		vertical-align: middle;
		margin-right: 11px;
	}

	.Icon3:before {
		content: "";
		background: url(../assets/images/eamil.png) no-repeat;
		display: inline-block;
		width: 21px;
		height: 15px;
		background-size: 21px 15px;
		vertical-align: middle;
		margin-right: 9px;
	}

	.Icon4:before {
		content: "";
		background: url(../assets/images/website.png) no-repeat;
		display: inline-block;
		width: 24px;
		height: 24px;
		background-size: 24px 24px;
		vertical-align: middle;
		margin-right: 7px;
	}
	/*中国信息办事处结束*/

	.c1 {
		font-size: 26px;
		color: #fff;
		margin-bottom: 22px;
	}

	.friend {
		margin-top: 48px;
	}

	.friend-item {
		width: 85%;
		margin: 0 auto;
	}

	.friend-item li {
		font-size: 26px;
		color: rgba(255, 255, 255, 1);
		line-height: 30px;
		float: left;
		margin-right: 73px;
	}

	.friend-item li:last-child {
		margin-right: 0px;
	}

	.friend-item li a {
		color: rgba(255, 255, 255, 1);
	}

	.copyright {
		width: 100%;
		background: #182e37;
		padding-top: 15px;
		position: absolute;
		bottom: 0;
		padding: 10px 0;
	}

	.copyright-text p {
		font-size: 22px;
		color: #fff;
		text-align: center;
		line-height: 38px;
	}

	.copyright-text p a {
		color: #fff;
	}
</style>



// WEBPACK FOOTER //
// src/components/homeFooter.vue